import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Layout from '../../../brand/Layout/index';
// import CreatorsList from '../../../brand/Creators/CreatorsList';
// import CreatorContentList from '../../../brand/CreatorContent/CreatorContentList';
import CreatorDashboard from '../../../brand/CreatorDashboard';
import Settings from '../../../brand/Settings';
import ContentList from '../../../brand/MediaContent/index';
import ContentApprovalsList from '../../../brand/MediaContent/Approvals';
import PipelineDeals from '../../../brand/ConfirmedDeals/Pipeline';
import PublishedDeals from '../../../brand/ConfirmedDeals/Published';
import ProspectList from '../../../brand/Prospects/ProspectsList';
import Dashboard from '../../../brand/Dashboard';
import YouTubeVideoComment from '../../../brand/YouTubeVideoComment';
import CommentReport from '../../../brand/CommentReport';
import Report5cs from '../../../brand/CompanyReport';
import PriceApproval from '../../../brand/PriceApproval';

import { useSelector } from 'react-redux';

export default () => {
  const enablePriceApprovalsOnBrandPortal = useSelector(state => state.session?.advertiser?.enablePriceApprovalsOnBrandPortal);
  const displayBrandConfirmedDeals = useSelector(state => state.session?.advertiser?.displayBrandConfirmedDeals);
  const isOwner = useSelector(state => state.session?.role === 'owner');
  return (
  <div>
    <Layout />
    <div className="container__wrap no_left_menu">
      <Switch>
        <Route
          path="/"
          exact
          component={Report5cs}
        />
        <Route
          path="/creators/list"
          exact
          component={Dashboard}
        />
        <Route
          path="/creator/:creatorId"
          exact
          component={CreatorDashboard}
        />
        {enablePriceApprovalsOnBrandPortal && (
          <Route
            path="/price-approval"
            exact
            component={PriceApproval}
          />
        )}
        <Route
          path="/content"
          exact
          component={ContentList}
        />
        <Route
          path="/content-approvals"
          exact
          component={ContentApprovalsList}
        />
        {displayBrandConfirmedDeals && isOwner && (
          <Route
            path="/deals-pipeline"
            exact
            component={PipelineDeals}
          />
        )}
        {displayBrandConfirmedDeals && isOwner && (
          <Route
            path="/deals-published"
            exact
            component={PublishedDeals}
          />
        )}
        <Route
          path="/settings"
          exact
          component={Settings}
        />
        <Route
          path="/prospects"
          exact
          component={ProspectList}
        />
        <Route
          path="/company-report"
          exact
          component={Report5cs}
        />
        {isOwner && (
          <Route
            path="/comments"
            exact
            component={YouTubeVideoComment}
          />
        )}
        {isOwner && (
          <Route
            path="/youtube-comments-analysis"
            exact
            component={CommentReport}
          />
        )}
      </Switch>
    </div>
  </div>
);
};
